<template>
    <div class="goToMarket">
        <div
            class="button switchListTo test"
            v-bind:class="[buttonStyle, `JARVIS_MatchCardList_Btn_go${switchToMarketText}Market`]"
            v-on:click="switchToOtherMarket"
        >
            {{ switchToMarketTranslation }}
        </div>
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent, toRefs } from 'vue';
    import { MarketPage } from '@/interface/enum';
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
    import { i18n } from '@/libraries/i18n';
    import { scrollToTop } from '@/libraries/utils/dom';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'SwitchToOtherMarket',
        props: {
            switchTo: {
                type: String as PropType<MarketPage>,
                default: MarketPage.Unknown,
            },
            hasMatch: {
                type: Boolean,
                default: true,
            },
        },
        setup(props) {
            const { switchTo } = toRefs(props);
            const switchToMarketText = computed(() => {
                switch (switchTo.value) {
                    case MarketPage.EarlyMarket:
                        return 'EarlyMarket';
                    case MarketPage.Today:
                        return 'Today';
                    default:
                        return 'Live';
                }
            });
            const switchToMarketTranslation = computed(() => {
                switch (switchTo.value) {
                    case MarketPage.EarlyMarket:
                        return i18n.t('marketPage_goToEarlyMarket');
                    case MarketPage.Today:
                        return i18n.t('marketPage_goToToday');
                    default:
                        return getTranslationBySite('go_to_live');
                }
            });

            const buttonStyle = computed(() => {
                if (props.hasMatch) {
                    return '_secondary';
                }
                return '_primary';
            });

            function switchToOtherMarket() {
                useRootStore().updateMarketPage(props.switchTo);
                scrollToTop(300);
            }

            return {
                i18n,
                switchToMarketText,
                switchToMarketTranslation,
                buttonStyle,
                switchToOtherMarket,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/indiaSite/components/oddsDisplay";

    .goToMarket {
        padding: 1rem;
    }

    .noMatches {
        .goToMarket {
            padding: 0 1.2rem;

            .button {
                width: 85%;
                margin: 2rem auto 0;
                font-size: 1.6rem !important;
            }
        }
    }
</style>
